/* Levers footer, "fold" option: on phones the menus after the first fold behind their heading.
   The server renders every menu open and the heading button hidden, so without this script
   nothing is ever hidden. The script reveals the buttons below 750px (and hides the plain heading
   text they replace); above 750px it hides the buttons and opens everything. Panels are
   independent, the button keeps focus, and aria-expanded and the panel's hidden attribute always
   move together. Re-runs when the theme editor reloads the section. (docs/footer-redesign-oct-2026) */
(function () {
  function init() {
    var root = document.querySelector('.lv-footer--fold');
    if (!root || root.__lvFoldInit) return;
    root.__lvFoldInit = true;
    window.__lvAccordionRan = true;
    var mq = window.matchMedia('(max-width: 749px)');
    var items = [].slice.call(root.querySelectorAll('.lv-footer__menu[data-lv-collapsible]'));

    function setOpen(item, open) {
      var button = item.querySelector('.lv-footer__toggle');
      var panel = item.querySelector('.lv-footer__panel');
      if (!button || !panel) return;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    function apply() {
      var small = mq.matches;
      items.forEach(function (item) {
        var button = item.querySelector('.lv-footer__toggle');
        var text = item.querySelector('.lv-footer__heading-text');
        if (!button) return;
        button.hidden = !small;
        if (text) text.hidden = small;
        if (small) {
          setOpen(item, item.getAttribute('data-lv-open') === 'true');
        } else {
          setOpen(item, true);
        }
      });
    }

    items.forEach(function (item) {
      var button = item.querySelector('.lv-footer__toggle');
      if (!button) return;
      button.addEventListener('click', function () {
        var open = button.getAttribute('aria-expanded') === 'true';
        item.setAttribute('data-lv-open', open ? 'false' : 'true');
        setOpen(item, !open);
      });
    });

    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
